export default function getHeaders(params) {
  const token = window.localStorage.getItem('access_token');
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };
  if (!params || !params.noAuth) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
}



// WEBPACK FOOTER //
// ./src/services/getHeaders.js